import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IZBk665 = ({ question, answer }) => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings_Banner.png";
    const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}

                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}

            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank Commits K66.5 Million to ZESCO’s Green Energy Initiative in Chadiza!</h1>


                    <p className="pb-3">Indo Zambia Bank (IZB) and @zesco.zm Limited have signed a landmark K66.5 million Facility Agreement under the Bank of Zambia’s Stability and Resilience Facility (SRF), marking a crucial step in strengthening Zambia’s energy security against drought and electricity supply challenges.</p>

                    <p className="pb-3">During the signing ceremony held at Indo House, Indo Zambia Bank Corporate Head Office, IZB Managing Director, Mr. Brajesh Kumar Singh said “The funds being extended to ZESCO are not merely a financial facility; This facility represents a deliberate investment in Zambia’s ongoing energy development efforts, building on work already underway and anchored in a vision of advancing community development. This support through this SRF facility will make a tangible difference in Chadiza through ZESCO’s city Greening innovation. Chadiza as we understand is a community that has long endured unstable power supply due to unreliable generation. By bringing generation capacity closer to the people, the project will stabilize supply, reduce outages, and transform lives. It will power schools, health facilities, businesses and households, unlocking new opportunities for enterprise and education while driving economic activity. The resulting ripple effects will drive broader prosperity in Chadiza and beyond.’’</p>


                    <p className="pb-3">In additional, IZB Managing Director, emphasized that this is a "deliberate investment in Zambia’s energy diversification and climate resilience agenda," moving the nation beyond its reliance on drought-prone hydro sources.</p>

                    <p className="pb-3">ZESCO Managing Director, Eng. Justin Loongo, hailed the facility as a clear endorsement of “Zambia’s path towards a low-carbon, energy-secure future.” He stated: “This project is a vital step in ZESCO’s strategy to diversify its energy mix and strengthen grid reliability, bringing clean, stable electricity to more Zambians. This system will store excess energy and make it available when it’s needed most, at night or during peak demand.”</p>

                    <p className="pb-3"><b><em>#IZBFosteringGrowth #SupportingYouDevelopingZambia #ZESCO #GreenEnergy</em></b></p>

                    <h2 className="pt-4 pb-4">Gallery</h2>

                    <div className="test news-slider-list-slider row align-items-center">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-commits-k665-million-to-zescos-green-energy-initiative-in-chadiza-thumb.jpg" alt="" />
                            </div>
                        </Slider>
                    </div>
                </div>

            </section>

            <CustomerCare />
            <OurStores />

        </>
    );
};

export default IZBk665;